import React from "react";

// Web counterpart of the native SVG gradient: same brand wash (mint top right →
// deep ink-green bottom left, 10% opacity), but as a plain CSS gradient so the
// webpack build stays free of react-native-svg.
export default function PlaceholderGradient() {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundImage:
          "linear-gradient(to bottom left, rgba(140, 193, 159, 0.1), rgba(22, 81, 71, 0.1))",
        pointerEvents: "none",
      }}
    />
  );
}
